export const simuladorApi = true;
